export const simuladorApi = true;
